import { createSelector } from "reselect";
import { initialState } from "./reducer";
import { compareString } from "helpers/generalUtils";

const reducerState = (state) => state.ProductCategoryMaster || initialState;

const makeProductCategorySelectField = (field) =>
  createSelector(
    reducerState,
    (productCategoryState) => productCategoryState[field]
  );

const selectSortedProductCategories = () =>
  createSelector(
    makeProductCategorySelectField("productCategoryData"),
    (productCategories) =>
      productCategories
        .map((opt) => ({
          value: opt.productCategoryId,
          label: opt.productCategoryName,
        }))
        .sort((item1, item2) => compareString(item1.label, item2.label))
  );

export {
  reducerState,
  makeProductCategorySelectField,
  selectSortedProductCategories,
};
